import debug from './debug';
/**
 * Embed Image tag into a parent selector
 *
 * @return Promise
 */
export const loadImgTag = (url, parent = 'body') => new Promise(resolve => {
    const parentElm = document.querySelector(parent);
    const element = document.createElement('img');
    element.src = url;
    element.onload = () => resolve(url);
    element.onerror = () => {
        debug('Cannot load image: ', url);
        resolve(url);
    };
    parentElm && parentElm.appendChild(element);
});
